const defaultBiddingSettings = {
    handlingFees: { amount: 15000, percentage: 0, isPercentageDefault: true },
    margin: { amount: 2000, percentage: 0, isPercentageDefault: true },
    urgentBidPeriod: { value: 10, unit: 'minute' as const },
    notUrgentBidPeriod: { value: 60, unit: 'minute' as const },
    enableUpcomingBidNotification: false,
    maxDealCount: 3,
    topDealCount: 3,
    maxSalesTransactionPhotos: 10,
};

export default defaultBiddingSettings;
